<style scoped>
    .complete {
        background: #DDF2BB;
        color: black;
        height: 2em !important;
        overflow: hidden;
    }

    .incomplete {
        background: #F39797;
        height: 2em !important;
        overflow: hidden;
    }

    .tile--content {
        font-size: 1em !important;
        margin-top: -1em;
    }

</style>

<template>
    <v-list v-model="selectedStudentId">
      <v-subheader >Students</v-subheader>
      <v-list-tile v-bind:class="{ 'complete': studentItem.incompleteGrades == 0, 'incomplete': studentItem.incompleteGrades != 0 }"
        v-bind:model="selectedStudentId==studentItem.id" v-for="studentItem in students" :key="studentItem.Id" 
        @click="studentSelected(studentItem)"
       >
        <v-list-tile-content class="tile--content">
            <v-list-tile-title >{{ studentItem.lastName }}, {{ studentItem.firstName }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    
</template>
<script>
    import { getStudentsForClass, getReportingPeriodClassId } from '../utils/effort-tracking-api';
    import { globalStore } from '../main'

    export default {
        name:  'class-students',
        props: [ 'classId', 'teacherId' ],
        data () {
            return {
                students: [],
                selectedStudentId: '0',
                incompleteGrades: -1,
                studentGraded: []
            }
        },
        watch: {
            classId: function(val) {
                // Load students list
                this.update();
            },
            incompleteGrades: {
                handler(value) {
                    // console.log(val);
                }
            }
        },
        methods: {
            update() {
                if (this.classId != 0) {
                    getStudentsForClass(this.classId, this.teacherId)
                    .then(students => {
                        this.$store.state.classStudents = students;
                        this.students = students
                    });
                }        
            },
            refresh(data, classId) {
                var student = this.$store.state.classStudents.filter(st => st.id == data.studentId)[0];
                var grades = student.grades;
                var incomplete = grades.some(sg => sg.grade == 0);

                this.$store.state.classStudents.filter(st => st.id == data.studentId)[0] = student;
                student.incompleteGrades = (incomplete) ? 1 : 0;
                this.incompleteGrades = student.incompleteGrades;
                this.studentGraded = student;
            },
            reset() {
                this.students = [];
            },
            getRPClassId(classId, periodId) {
                return getReportingPeriodClassId(classId, periodId).then(response => response[0]);
                
            },
            studentSelected(student) {
                var tempDiv =  document.createElement('div');
                tempDiv.setAttribute('id', student.id);
                tempDiv.setAttribute('class', 'temp-div');
                
                var tab = document.getElementsByClassName('v-tabs__item v-tabs__item--active')[0];
                if (tab != undefined && tab != null)
                {
                    var tabName = tab.innerText.split('\n')[0].toLowerCase();
                    var elem = document.getElementById(tabName + '_card_' + student.id);
                    var positionId = tabName + '_' + student.id;
                    tempDiv.setAttribute('id', positionId);

                    if (elem != undefined && elem != null)
                    {
                        elem.insertAdjacentElement('beforebegin', tempDiv);
                    }
                }
                
                window.location.href = "#" + positionId;
            }
        },
        mounted() {
            this.update();
        },

    }
</script>


// WEBPACK FOOTER //
// src/components/ClassStudentsList.vue